import React from 'react';
/*
 * Bronson ResponsiveImage component.
 */
export function ResponsiveImage({ src, srcSet, sizes, alt, testId, children, ...otherProps }) {
    return (React.createElement("figure", { "data-testid": testId },
        React.createElement("img", { src: src, srcSet: srcSet, sizes: sizes, alt: alt, ...otherProps }),
        children && React.createElement("figcaption", null, children)));
}
